export const getOriginUrlQueryParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('origin') ?? 'undefined origin';
};
